import { render, staticRenderFns } from "./paramSet.vue?vue&type=template&id=33e8fd9c&scoped=true"
import script from "./paramSet.vue?vue&type=script&lang=js"
export * from "./paramSet.vue?vue&type=script&lang=js"
import style0 from "./paramSet.vue?vue&type=style&index=0&id=33e8fd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8fd9c",
  null
  
)

export default component.exports